const colors = {
  grey20: "#F2F2F2",
  grey40: "#AAAAAA",
  pink: "#D25E85",
  secondary: "#424242",
  greyBackground: "#303030",
};

export default colors;
